import icon from "../../assets/hand.svg";
import type { Property } from "../../types";

export const hand: Property = {
  id: "hand",
  title: "hand.title",
  icon,
};
